module.exports = __webpack_public_path__ + "main-logged-out-58e5f421/premium_375-0d6d7fc0bed8f16287ee5c41d560dfd5.png";